import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import actorsPropertiesStore from "./actors_properties_store.js";
import gameActorsStore from "./game_actors_store.js";
import previewMeasureStore from "./preview_measure_store.js";

export function initVueStore(privatePubUrl = undefined) {
	window.VueStore = new Vuex.Store({
		modules: {
			actorsPropertiesStore: actorsPropertiesStore,
			previewMeasureStore: previewMeasureStore,
			gameActorsStore: gameActorsStore,
		},
	});
	if (privatePubUrl === undefined) {
		return; // Should only happen when initializing in CMS
	}
	PrivatePub.subscribe(privatePubUrl, function (data, channel) {
		handleSyncData(data);
	});
}

function handleSyncData(data) {
	// pp.log("into handleSyncData", data);
	if (!Object.keys(window.VueStore._mutations).includes(data.update_function)) {
		// pp.log("- could not find update function in own mutations")
		return;
	}
	// console.log(data.newApps.map(function(ap) {
	// 	return ap.property.type_key + ": " + ap.current_value
	// }).join('\n'));

	// Unionslabor: If this is for the current actor then wait a bit so that `onNationalMeasureEnacted` can call markTransitionOmissionOfProperties first
	const timeout =
		data.update_function == "updateActorsPropertiesFor" &&
		pp.currentActorId == data.actorId
			? 500
			: 1;
	window.setTimeout(() => {
		window.VueStore.commit(data.update_function, data.payload);
	}, timeout);
}

export default initVueStore;
